import React from 'react';
import cn from 'classnames';

import { Button } from '@loyalup/ui';

import s from './TermsAndConditions.module.css';

const TermsAndConditions = () => (
  <div className={s.root}>
    <div className={s.page}>
      <h1>Лицензионный договор</h1>
      <h2>о предоставление права на использование компьютерной программы «LoyalUp»</h2>
      <p>
        Данный Договор регламентируют правоотношения между обществом с ограниченной ответственностью «ЛОЯЛ АП» (443011,
        Россия, г. Самара, ОГРН 1196313057852), далее – «Лицензиат», и Пользователем (юридическим лицом) компьютерной
        программы «Loyal Up», далее – «Лицензиар», связанные с операциями по поставке Лицензиару программной продукции и
        предоставлению ему неисключительного разрешения (права) на использование компьютерной программы «Loyal Up».
      </p>
      <ol className={s.list}>
        <li>
          Термины и общие положения, используемые в настоящем Договоре
          <ol className={s.list}>
            <li>
              «Loyal Up» – компьютерная программа, объект права интеллектуальной собственности общества с ограниченной
              ответственностью «ЛОЯЛ АП» (далее — Лицензиар), созданный (разработанный) по модели SaaS (англ. Software
              as a service – программное обеспечение как услуга) с целью облачной автоматизации маркетинга для заведений
              торговли (кафе, ресторанов, магазинов и т.д.).
            </li>
            <li>
              Полное описание «Loyal Up» (далее – Компьютерная программа) находится на сайте https://loyal-up.com.
            </li>
            <li>
              Настоящий Договор является открытым и общедоступным документом. Действующая редакция Договора
              располагается в сети Интернет по адресу: https://platform.loyal-up.com/user-agreement
            </li>
            <li>
              Настоящий Договор является договором присоединения и может быть заключен только путем присоединения
              Лицензиара ко всем условиям Договора в целом. Такое присоединение осуществляется, и настоящий Договор
              признается заключенным с момента его акцепта (принятия условий) Лицензиаром. Акцептом в целях настоящего
              Договора является факт выплаты Лицензиату платежа (далее – «Роялти») как вознаграждения за предоставление
              Лицензиару неисключительного разрешения (права) на использование Компьютерной программы.
            </li>
            <li>
              Лицензиар является владельцем данных, которые создаются Лицензиаром (накапливаются) с помощью Компьютерной
              программы.
            </li>
            <li>
              Обращения, предложения и претензии Лицензиара, связанные с использованием/ функционированием Компьютерной
              программы, могут быть направлены на электронный адрес info@loyal-up.com.
            </li>
            <li>
              Принимая условия настоящего Соглашения, Лицензиар подтверждает свое право- и дееспособность, подтверждает
              достоверность своих персональных данных и принимает на себя всю ответственность за их точность, полноту и
              достоверность.
            </li>
            <li>
              Территория, на которую распространяется предоставляемое по этому Договору право на использование
              Компьютерной программы, не ограничена.
            </li>
            <li>Адрес электронной почты Лицензиата по этому Договору: info@loyal-up.com.</li>
            <li>
              Адрес электронной почты Лицензиара по настоящему Договору указывается при регистрации на странице
              https://platform.loyal-up.com/register.
            </li>
          </ol>
        </li>
        <li>
          Предмет договора
          <ol className={s.list}>
            <li>
              Согласно условиям, определенным настоящим Договором, Лицензиат, имея на основании лицензионного договора
              неисключительное право предоставлять неисключительное разрешение (право) на использование Компьютерной
              программы (далее – Право), предоставляет такое Право Лицензиару.
            </li>
            <li>
              Право предоставляется Лицензиару (и никаким иным третьим лицам) исключительно в объеме, указанном в
              настоящем Договоре, если нет письменного согласия Лицензиата на иное.
            </li>
            <li>
              Лицензиар будет использовать Компьютерную программу на собственном оборудовании (планшет, смартфон,
              компьютер и т.п.) для своей хозяйственной деятельности путем доступа к ней через сеть Интернет.
            </li>
          </ol>
        </li>
        <li>
          Порядок приема-передачи Компьютерной программы
          <ol className={s.list}>
            <li>
              Прием-передача Лицензиатом Лицензиару Компьютерной программы в пользование происходит путем доступа к ней
              через сеть Интернет.
            </li>
            <li>Компьютерная программа размещена по адресу в сети Интернет: https://loyal-up.com.</li>
          </ol>
        </li>
        <li>
          Размер, порядок и сроки выплаты платежей за использование Компьютерной программы
          <ol className={s.list}>
            <li>
              Лицензиар за предоставление Права выплачивает Лицензиату Роялти в соответствии с выбранным тарифным
              планом.
            </li>
            <li>
              Роялти, указанное в п.4.1. этого раздела, выплачивается Лицензиаром в безналичной форме на расчетный счет
              Лицензиата путем перечисления 100% суммы, указанной в счете, выставленном Лицензиатом или посредством
              оплаты привязанной кредитной\дебетовой карты.
            </li>
            <li>
              При первичной оплате Лицензиар оплачивает выставленный Лицензиатом счет путем перечисления 100% суммы,
              указанной в счете до 00.00 часов дня начала использования Компьютерной программы.
            </li>
            <li>
              В дальнейшем Лицензиат оплачивает выставленный Лицензиатом счет путем перечисления предоплаты — 100%
              суммы, указанной в счете за 3 (три) рабочих дня первого дня очередного периода использования Компьютерной
              программы.
            </li>
            <li>
              В случае неоплаты Роялти до 00.00 часов дня начала периода использования Компьютерной программы, Лицензиат
              оставляет за собой право прекратить предоставление Права, расторгнуть Договор в одностороннем порядке и
              заблокировать доступ Лицензиара к Компьютерной программе. При этом Лицензиат не несет ответственность
              перед Лицензиаром за любые убытки, связанные с блокировкой доступа к Компьютерной программе по причине
              несвоевременной оплаты Лицензиату Роялти, в том числе и в случае, если Лицензиат был предупрежден о
              возможности появления таких убытков вследствие блокировки доступа к Компьютерной программе.
            </li>
            <li>
              Моментом исполнения Лицензиаром обязанностей по оплате Роялти является дата поступления денежных средств,
              в полном объеме, на расчетный счет Лицензиата.
            </li>
            <li>
              В случае отказа Лицензиара от дальнейшего использования Компьютерной программы или одностороннего
              расторжения договора по инициативе Лицензиара, средства, оплаченные как предоплата за предоставления
              Права, возврату не подлежат.
            </li>
            <li>
              В случае отказа Лицензиата от дальнейшего предоставления Лицензиару Права или одностороннего расторжения
              договора по инициативе Лицензиата, средства, оплаченные как предоплата за предоставление Права, подлежат
              возврату Лицензиару на указанный им счет. Указанное в настоящем пункте правило о возврате средств
              Лицензиару не распространяется в случае расторжения Договора вследствие нарушения Лицензиаром пункта 6.3
              настоящего Договора.
            </li>
            <li>
              Условия тарифных планов могут быть изменены в одностороннем порядке на новый период предоставления Права.
              В случае несогласия Лицензиаром с указанными изменениями, о чем свидетельствует отсутствие оплаты Роялти,
              Договор считается расторгнутым. При этом предоставление Права, оплаченное Лицензиаром до момента внесения
              таких изменений, будет выполнено Лицензиатом без учета таких изменений.
            </li>
          </ol>
        </li>
        <li>
          Права и обязанности сторон
          <ol className={s.list}>
            <li>
              Лицензиат имеет право:
              <ol className={s.list}>
                <li>
                  Вносить изменения в Компьютерную программу и усовершенствовать ее, без предварительного уведомления;
                </li>
                <li>
                  Направлять Лицензиару любым способом информацию о функционировании Компьютерной программы, в том числе
                  направлять рекламные, информационные и иные сообщения на адрес электронной почты или номер телефона,
                  указанный Лицензиаром, или размещать соответствующую информацию в Компьютерной программе;
                </li>
                <li>
                  С учетом пункта 13.2. этого Договора, осуществлять обработку данных Лицензиар для улучшения сервиса и
                  сбора статистики по рынку;
                </li>
                <li>Получать от Лицензиара Роялти за предоставление ему Права;</li>
                <li>
                  Досрочно в одностороннем порядке расторгнуть этот Договор, в случае нарушения Лицензиаром условий
                  настоящего Договора, незамедлительно блокировать доступ и прекратить предоставление Права без
                  предварительного уведомления Лицензиара и возмещения, понесенных Лицензиаром, в связи с этим, убытков;
                </li>
                <li>
                  На одностороннее внесение изменений в условия настоящего Договора. При этом продолжение использования
                  Компьютерной программы и оплата Лицензиаром предоставленного Права, после внесения изменений и/или
                  дополнений в настоящий Договор, означает согласие Лицензиара с такими изменениями и/или дополнениями.
                </li>
                <li>
                  Инициировать расторжение настоящего Договора в соответствии с условиями Договора и действующим
                  законодательством;
                </li>
                <li>
                  Без предварительного уведомления Лицензиара ограничить, приостановить или прекратить предоставление
                  Права без возмещения Лицензиару понесенных убытков, в случае, если у Лицензиата имеются данные
                  полагать, что Лицензиат или его аффилированные лица (умышленно или неумышленно):
                  <ul className={s.sublist}>
                    <li>
                      при использовании Компьютерной программой нарушают законодательство, положения этого Договора или
                      права и законные интересы третьих лиц;
                    </li>
                    <li>пользуются Компьютерной программой недобросовестно;</li>
                    <li>причиняют вред Компьютерной программе или ее работоспособности;</li>
                    <li>осуществляют попытки несанкционированного доступа к Компьютерной программе;</li>
                    <li>
                      создают угрозу сбоя технических и/или программных средств Компьютерной программы и/или третьих
                      лиц;
                    </li>
                  </ul>
                </li>
                <li>
                  Передавать права и обязанности по настоящему Договору, третьим лицам в целях исполнения настоящего
                  Договора без дополнительного согласия Лицензиара.
                </li>
                <li>Пользоваться другими правами, предусмотренными действующим законодательством.</li>
                <li>Лицензиат имеет неисключительное имущественное право предоставлять Право.</li>
                <li>
                  Статус Лицензиара, предоставляемый в рамках этого договора, не является эксклюзивным, и Лицензиат
                  имеет право на заключение подобных договоров.
                </li>
              </ol>
            </li>
            <li>
              Лицензиат обязан обеспечить:
              <ol className={s.list}>
                <li>
                  Выполнение Компьютерной программой функциональных возможностей, описанных в технической документации к
                  ПО;
                </li>
                <li>
                  Доступ к Компьютерной программе для ее использования Лицензиаром в течение 99.8% времени последних 365
                  дней (за исключением времени проведения профилактических работ);
                </li>
                <li>Конфиденциальность данных Лицензиара на весь период их нахождения на серверах.</li>
                <li>
                  Базовую информационную безопасность данных Лицензиара в пределах, определяемых обычными условиями.
                </li>
                <li>
                  Устранение сбоев в работе Компьютерной программы или ошибок, выявленных Лицензиаром в течение срока
                  действия этого Договора;
                </li>
                <li>
                  Предоставление Лицензиару, в период действия этого Договора, удаленной информационно-технической
                  поддержки для обеспечения нормального функционирования Компьютерной программы; Удаленная
                  информационно-техническая поддержка Компьютерной программы предоставляется Лицензиару в порядке и на
                  условиях настоящего Договора.
                </li>
              </ol>
            </li>
            <li>
              Лицензиар имеет право:
              <ol className={s.list}>
                <li>
                  Использовать Компьютерную программу в течение срока действия Договора и в соответствии с условиями,
                  определенными в нем;
                </li>
                <li>
                  Инициировать расторжение настоящего Договора в соответствии с условиями Договора и действующим
                  законодательством;
                </li>
                <li>Вносить предложения по изменению/дополнению функциональных возможностей Компьютерной программы;</li>
                <li>Выбирать тарифный план пользования Компьютерной программой;</li>
                <li>Предоставлять сотрудникам организации Лицензиара доступ для работы в Компьютерной программе;</li>
                <li>
                  Использовать Компьютерную программу в хозяйственной деятельности, исключая случаи перепродажи, аренды
                  или передачи Компьютерной программы третьим лицам;
                </li>
              </ol>
            </li>
            <li>
              Лицензиар обязан:
              <ol className={s.list}>
                <li>
                  Выплачивать Лицензиату Роялти в размерах, порядке и сроках, определенных настоящим Договором, за
                  использование Компьютерной программы;
                </li>
                <li>
                  Сообщать Лицензиату обо всех известных ему случаях нарушения третьими лицами имущественных прав
                  интеллектуальной собственности на Компьютерную программу;
                </li>
                <li>
                  Ознакомиться со всей информацией, размещенной на сайте loyal-up.com, а также регулярно следить за
                  всеми изменениями. Акцепт Лицензиаром этого Договора подтверждает выполнение им указанного в этом
                  пункте обязательства;
                </li>
                <li>
                  Не использовать Компьютерную программу в нарушение прав и законных интересов Лицензиара, Лицензиата,
                  иных правообладателей, третьих лиц и настоящего Договора;
                </li>
                <li>
                  Использовать Компьютерную программу исключительно в соответствии с условиями и в рамках определенными
                  этим Договором;
                </li>
                <li>Не совершать действий, указанных в п. 6.3. раздела 6 настоящего Договора;</li>
                <li>
                  Своевременно направлять уведомления Лицензиату о необходимости уничтожения данных/информации на
                  серверах;
                </li>
                <li>
                  Предоставить Лицензиату все сведения и документы, необходимые для выполнения Лицензиатом своих
                  обязательств по настоящему Договору;
                </li>
                <li>
                  Регулярно отслеживать изменения в Договоре, размещенном на сайте
                  https://platform.loyal-up.com/user-agreement
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          Условия использования Компьютерной программы
          <ol className={s.list}>
            <li>
              Лицензиар не получает права собственности или авторского права на Компьютерную программу. Компьютерная
              программа остается собственностью Лицензиара. Стороны подтверждают, что в соответствии с законодательством
              РФ, с учетом условий данного Договора, Лицензиат передает Лицензиару только Право.
              <br />
              <br />
              При этом такая передача не является передачей ни во владение, ни в распоряжение, ни в собственность.
              Право, которое было передано, исключает право или возможность Лицензиара продать или осуществить
              отчуждение в другой способ Компьютерной программы любому третьему лицу, а также исключает возможность
              Лицензиара иным образом передать Компьютерную программу во владение, распоряжение или собственность любому
              третьему лицу.
              <br />
              <br />
              Условия использования Компьютерной программы не ограничены ее функциональным назначением, и ее
              воспроизведение не ограничено количеством копий, необходимых для такого использования.
            </li>
            <li>
              Лицензиар может использовать Компьютерную программу следующими способами:
              <ol className={s.list}>
                <li>
                  Воспроизводить графическую часть Компьютерной программы (рабочий интерфейс) на экране своего
                  оборудования (планшета, смартфона, компьютера и т.п.);
                </li>
                <li>
                  Использовать все функциональные возможности Компьютерной программы, описанные технической
                  документации;
                </li>
              </ol>
            </li>
            <li>
              Лицензиару запрещается:
              <ol className={s.list}>
                <li>
                  Прибегать к обратному конструированию, декомпиляции или дизассемблированию Компьютерной программы, или
                  иным образом исследовать программный код и/или модифицировать его;
                </li>
                <li>
                  Предоставлять Компьютерную программу в прокат или во временное пользование третьим лицам, за
                  исключением сотрудников Лицензиара, которые используют Компьютерную программу с целью ведения
                  хозяйственной деятельности Лицензиара;
                </li>
                <li>
                  Заключать сублицензионные договора с третьими лицами и/или передавать третьим лицам Право на
                  Компьютерную программу;
                </li>
                <li>Производить взлом платного функционирования Компьютерной программы.</li>
              </ol>
            </li>
            <li>
              Для исполнения настоящего Договора Лицензиатом могут привлекаться третьи лица. Лицензиар подтверждает, что
              указанным третьим лицам предоставляются такие же права, как и Лицензиату, в том числе в отношении
              персональных данных Лицензиара.
            </li>
            <li>
              В случае нарушения Лицензиаром условий этого Договора или осуществления любого действия, указанного в
              подпунктах п. 6.3. настоящего Договора, действие настоящего Договора прекращается, а Лицензиар должен
              немедленно прекратить использование Компьютерной программы с момента прекращения действия настоящего
              Договора и возместить Лицензиату реальные убытки, упущенную выгоду и моральный (неимущественный) вред
              (ущерб).
            </li>
            <li>
              В случае, если в течение 3 (трех) дней с момента получения Права Лицензиат не получил претензий
              Лицензиара, связанных с объемом предоставленных прав, то Право считается предоставленным Лицензиару в
              полном объеме надлежащим образом.
            </li>
            <li>
              В случае расторжения Договора информация Лицензиара, внесенная в Компьютерную программу, может быть
              уничтожена/удалена.
            </li>
          </ol>
        </li>
        <li>
          Порядок осуществления удаленной информационно-технической поддержки
          <ol className={s.list}>
            <li>
              В настоящем Договоре под удаленной информационно-технической поддержкой понимается поддержка рабочего
              состояния Компьютерной программы, актуализация (периодическое обновление) Компьютерной программы, в
              течение действия этого Договора.
            </li>
            <li>
              Удаленная информационно-техническая поддержка (далее – «УИТП»), которая бесплатно осуществляется
              Лицензиатом в рамках настоящего Договора, включает:
              <ul className={s.sublist}>
                <li>
                  подготовку дополнений и изменений программного кода Компьютерной программы для его обновления, в том
                  числе в связи с устранением выявленных недоработок (недостатков) в Компьютерной программе;
                </li>
                <li>
                  консультационное обслуживание Лицензиара по вопросам функционирования Компьютерной программы и ее
                  программно-техническая поддержка в соответствии с тарифным планом;
                </li>
                <li>получение Лицензиаром обновлений Компьютерной программы.</li>
              </ul>
            </li>
            <li>
              Для предоставления Лицензиатом Лицензиару услуг, необходимость предоставления которых будет обнаружена
              Лицензиаром в ходе эксплуатации Компьютерной программы или УИТП, Стороны заключат отдельный договор, в
              котором определят перечень таких услуг, стоимость, порядок и сроки их выполнения.
            </li>
          </ol>
        </li>
        <li>
          Обстоятельства непреодолимой силы (форс-мажор)
          <ol className={s.list}>
            <li>
              Стороны не несут ответственности за неисполнение либо ненадлежащее исполнение обязательств по Договору,
              если это неисполнение (ненадлежащее исполнение) явилось прямым следствием наступления обстоятельств,
              которые Стороны не могли предвидеть и предотвратить разумными средствами. Обстоятельствами непреодолимой
              силы, в том числе, являются: стихийные бедствия, эпидемии, война, военные перевороты, мятеж, гражданские
              волнения, антитеррористические операции, террористические акты, забастовки, акты органов законодательной
              и/или исполнительной власти, пожар, реквизиция, мобилизация, арест, валютные ограничения, эмбарго или
              блокады, торговые санкции.
            </li>
            <li>
              В случае наступления указанных в п. 8.1. данного раздела Договора обстоятельств, срок исполнения
              обязательств по Договору отодвигается соразмерно времени действия таких обстоятельств.
            </li>
            <li>
              Сторона, для которой создалась невозможность исполнения обязательств, предусмотренных условиями настоящего
              Договора, должна немедленно, но не позднее 10 (десяти) рабочих дней с момента наступления указанных
              обстоятельств в электронной форме уведомить другую Сторону.
            </li>
            <li>
              В случае, если действие обстоятельств, указанных в п. 8.1. данного раздела Договора, продлится более 2
              (двух) месяцев, или если имеются достаточные основания полагать, что обстоятельства непреодолимой силы
              будут продолжаться более чем 2 (два) месяца, то Сторона, для которой существует невозможность исполнения
              обязательств по настоящему Договору, вправе отказаться от дальнейшего исполнения Договора.При этом Стороны
              должны согласовать план действий, определить возможные способы и произвести взаиморасчет средств с дня
              наступления такой возможности.
            </li>
          </ol>
        </li>
        <li>
          Ответственность сторон за нарушение условий договора
          <ol className={s.list}>
            <li>
              Лицензиат не несет ответственности за:
              <ol className={s.list}>
                <li>
                  Нанесение вероятных убытков, которые могут быть нанесены Лицензиару в результате использования
                  последним Компьютерной программы, в том числе убытков, которые нанесены (могут быть нанесены) третьим
                  лицам;
                </li>
                <li>
                  Упущенную выгоду и негативные последствия, которые произошли в результате использования Компьютерной
                  программы и нанесли ущерб Лицензиару и третьим лицам;
                </li>
                <li>
                  Качество сервисов (в частности сервисов передачи данных) необходимых для работы с Компьютерной
                  программой предоставляемых Лицензиару третьими лицами.
                </li>
              </ol>
            </li>
            <li>
              В случае нарушения обязательств, которые возникают из настоящего Договора (далее именуется «нарушение
              Договора»), Сторона несет ответственность, определенную настоящим Договором и (или) действующим
              законодательством РФ.
            </li>
            <li>
              Нарушением Договора является его невыполнение или ненадлежащее выполнение, то есть выполнение с нарушением
              условий, определенных содержанием настоящего Договора.
            </li>
            <li>
              Сторона не несет ответственности за нарушение Договора, если оно произошло не по его вине (умысла или
              неосторожности).
            </li>
            <li>
              Сторона считается невиновной и не несет ответственности за нарушение Договора, если она докажет, что
              приняла все зависящие от нее меры для надлежащего исполнения настоящего Договора.
            </li>
            <li>
              Уплата штрафных санкций (штрафа, пени) не освобождает Стороны от исполнения своих обязательств по
              настоящему Договору.
            </li>
            <li>
              В случае доказательства прямой вины Лицензиата Лицензиар может получить от Лицензиата только возмещение за
              прямые убытки в размере не более стоимости 1 месяца подписки в рамках действующего тарифного плана.
              Лицензиар не имеет права на возмещение любых других убытков, в том числе косвенных убытков, утраченной
              выгоды, фактических или косвенных убытков.
              <br />
              <br />
              Это ограничение касается:
              <ul className={s.sublist}>
                <li>
                  любых споров, связанных с предоставлением Права, Компьютерной программой, службами и содержимым (в
                  частности, кодом) веб-сайтов третьих сторон или приложений третьих сторон;
                </li>
                <li>
                  исков о нарушении условий договора, гарантий, других условий или безусловных обязательств, о
                  проявлении халатности или совершения другого правонарушения, кроме случаев, предусмотренных
                  действующим законодательством.
                </li>
              </ul>
              Это ограничение действует, даже если представители Лицензиата знали или догадывались о возможности
              наступления таких убытков.
            </li>
            <li>
              Лицензиар соглашается с тем, что для работы с Компьютерной программой Лицензиару необходимо использовать
              программное обеспечение (веб-браузеры, операционные системы и прочее) и оборудование (персональные
              компьютеры, сетевое оборудование и прочее) произведенное и предоставленное третьими лицами, и Лицензиат не
              может нести ответственность за качество их работы.
            </li>
            <li>
              В случае потери данных, вызванной действиями Лицензиара, восстановление данных производится по запросу
              Лицензиату. Восстановление данных производится только при условии наличия технической возможности.
            </li>
          </ol>
        </li>
        <li>
          Гарантии и ответственность при использовании Компьютерной программы
          <ol className={s.list}>
            <li>
              Лицензиат гарантирует, что он является единственным владельцем авторских и/или смежных прав на
              Компьютерную программу и факт передачи Права Лицензиару по настоящему Договору не может нанести какой-либо
              вред любым третьим лицам.
            </li>
            <li>
              Компьютерная программа предоставляется в пользование по принципу «как есть». Лицензиат не несет
              ответственности за ошибки, сбои, сохранность данных Лицензиара и иные недостатки, и нарушения в
              Компьютерной программе и их последствия у Лицензиара, в том числе за реальный ущерб, упущенную выгоду,
              убытки, моральный вред, вред чести, достоинству и деловой репутации.
            </li>
            <li>
              Лицензиар принимает на себя все возможные риски, в том числе материальные, связанные с использованием
              Компьютерной программы.
            </li>
            <li>
              Лицензиар несет личную ответственность за доступ третьих лиц к устройству, на котором используется
              Компьютерная программа.
            </li>
            <li>
              В случае утери, удаления, повреждения внесенной пользователем в Компьютерную программу информации в
              результате действий/бездействий Лицензиара, всю ответственность несет Лицензиар.
            </li>
            <li>
              Лицензиат гарантирует исправление в удаленном режиме ошибок, выявленных Лицензиаром в работе Компьютерной
              программы, признанных Лицензиатом. Данная гарантия действительна при правильном использовании Компьютерной
              программы и не может быть применена в случаях ущерба, причиненного в результате:
              <ul className={s.sublist}>
                <li>
                  неправильного или несанкционированного использования, небрежности, некомпетентности, умышленной порчи,
                  действия компьютерных вирусов;
                </li>
                <li>
                  внешнего по отношению к Компьютерной программе или ее части характера, который включает, но не
                  ограничивается этим, перебои в энергии, перепады в напряжении и температуре или является результатом
                  неверного выполнения Лицензиаром технических указаний Лицензиата.
                </li>
              </ul>
            </li>
            <li>
              Лицензиар гарантирует, что не будет предпринимать каких-либо действий, направленных на причинение ущерба
              Лицензиату, правообладателям или иным третьим лицам.
            </li>
            <li>
              Лицензиат не несет ответственности за невозможность использования Компьютерной программы по причинам, не
              зависящим от Лицензиата.
            </li>
            <li>
              Лицензиат не несет ответственности за обеспечение достоверности, полноты, точности и актуальности
              информации, вносимой Лицензиаром в Компьютерную программу. Вся полученная от Лицензиара информация
              обрабатываются в том виде, как они были получены.
            </li>
            <li>
              Лицензиат не несет ответственности за несоблюдение Лицензиаром организационных и иных мер, приведших к
              неправомерному или случайному доступу к информации, неуполномоченных Лицензиаром лиц, а также повлекшее их
              уничтожение, изменение, блокирование, копирование или распространение, а также иные неправомерные действия
              со стороны сотрудников Лицензиара и/или третьих лиц.
            </li>
            <li>
              Лицензиат не может гарантировать работоспособность Компьютерной программы и не несет за это
              ответственность в случае, если у Лицензиара отсутствует последняя версия (своевременное обновление)
              необходимого программного обеспечения.
            </li>
          </ol>
        </li>
        <li>
          Разрешение споров
          <ol className={s.list}>
            <li>
              Все споры, возникающие из настоящего Договора или связанные с ним, решаются путем переговоров между
              Сторонами.
            </li>
            <li>
              Если соответствующий спор невозможно решить путем переговоров, он решается в судебном порядке по
              местонахождению Лицензиата в соответствии с действующим в РФ законодательством.
            </li>
          </ol>
        </li>
        <li>
          Срок действия Договора и порядок его расторжения
          <ol className={s.list}>
            <li>
              Настоящий договор вступает в силу с дня принятия условий настоящего Договора и действует в течение срока
              оплаченного предоставления Права. В случае внесения Лицензиаром дальнейшей оплаты за предоставление ему
              Права, до окончания срока действия этого Договора, этот Договор автоматически пролонгирует срок своего
              действия на период такой оплаты.
            </li>
            <li>
              Договор, может быть, расторгнут по соглашению сторон или по требованию Лицензиата в случаях,
              предусмотренных настоящим Договором.
            </li>
            <li>
              Любая из Сторон вправе в одностороннем порядке отказаться от настоящего Договора, уведомив другую Сторону
              путем направления сообщения средствами электронной связи. Моментом расторжения настоящего Договора
              считается дата, указанная в сообщении о расторжении Договора, а при отсутствии такого указания – дата
              электронной отправки Стороной данного сообщения.
              <br />
              Указанное в настоящем пункте правило по уведомлению Лицензиара не распространяется в случае расторжения
              Договора вследствие нарушения Лицензиаром пункта 6.3 настоящего Договора.
            </li>
            <li>
              Окончание срока действия настоящего Договора не освобождает Стороны от ответственности за его нарушение,
              которое имело место во время действия настоящего Договора.
            </li>
          </ol>
        </li>
        <li>
          Политика конфиденциальности
          <ol className={s.list}>
            <li>
              Политика конфиденциальности персональной информации (далее — Политика) действует в отношении всей
              информации, которую Лицензиат может получить о Лицензиаре во время регистрации на сайте loyal-up.com или
              использовании Компьютерной программы.
            </li>
            <li>
              Добровольная регистрация Лицензиара на сайте loyal-up.com c целью получения Права означает полное согласие
              в соответствии с законом «О персональных данных» на автоматизированную, а также без использования средств
              автоматизации, обработку и использование своих персональных данных, а также аудиозаписей, всех телефонных
              разговоров со специалистом УИТП Лицензиата и гарантирует достоверность предоставленных Лицензиаром
              персональных данных.
            </li>
            <li>
              В рамках настоящей Политики под «персональной информацией пользователя» понимаются:
              <ul className={s.sublist}>
                <li>
                  персональная информация, которую Лицензиар предоставляет о себе самостоятельно при регистрации или в
                  процессе использования Компьютерной программы, иная информация предоставляется Лицензиаром на его
                  усмотрение;
                </li>
                <li>
                  данные, которые автоматически передаются Компьютерной программой в процессе ее использования с помощью
                  установленного на устройстве пользователя программного обеспечения, в том числе IP-адрес, информация
                  из cookie, информация о браузере Лицензиара (или иной программе, с помощью которой осуществляется
                  доступ к Компьютерной программе), время доступа.
                </li>
              </ul>
            </li>
            <li>
              Настоящая Политика применима только к отношениям, которые возникают при использовании Компьютерной
              программы. Лицензиат не контролирует и не несет ответственность за сайты третьих лиц, на которые Лицензиар
              может перейти с помощью устройства на котором используется Компьютерная программа. На таких сайтах у
              Лицензиара может собираться или запрашиваться иная персональная информация, а также могут совершаться иные
              действия.
            </li>
            <li>
              Лицензиат собирает и хранит только те персональные данные, которые необходимы для предоставления Права,
              улучшения сервиса и оказания услуг, и которые могут быть использованы в следующих целях:
              <ul className={s.sublist}>
                <li>идентификация Лицензиара при предоставлении Права и использовании им Компьютерной программы;</li>
                <li>
                  связь с Лицензиаром, в том числе направление уведомлений, запросов и информации, касающихся
                  использования Компьютерной программы, оказания услуг, а также обработка запросов и заявок от
                  Лицензиара;
                </li>
                <li>таргетирование рекламных материалов;</li>
                <li>проведение статистических и иных исследований;</li>
                <li>общие сведения при работе в Компьютерной программе для ее оптимизации.</li>
              </ul>
            </li>
            <li>
              Лицензиат вправе передать персональную информацию Лицензиара третьим лицам в следующих случаях:
              <ul className={s.sublist}>
                <li>Лицензиар выразил свое согласие на подобное действие;</li>
                <li>
                  передача необходима в рамках выполнения Лицензиатом этого Договора и использования Лицензиаром
                  Компьютерной программы;
                </li>
                <li>
                  в целях выполнения требований закона или решений суда, для защиты прав и законных интересов
                  Лицензиата, защиты личной безопасности Лицензиаров Компьютерной программы.
                </li>
              </ul>
            </li>
            <li>
              Лицензиар может в любой момент изменить предоставленную им персональную информацию, а также удалить ее в
              рамках определенного аккаунта. Удаление аккаунта может повлечь невозможность использования Компьютерной
              программы.
            </li>
            <li>
              Лицензиат принимает необходимые организационные и технические меры для защиты персональной информации
              Лицензиара от неправомерного доступа, уничтожения, изменения, блокирования, копирования, распространения
              третьих лиц.
            </li>
            <li>
              Лица, считающие, что их права в использования персональных данных нарушены, или желающее отозвать свое
              согласие на обработку персональных данных могут направить уведомление на адрес электронной почты
              Лицензиата.
            </li>
            <li>
              Политика конфиденциальности и срок действия согласия Лицензиара на автоматизированную, а также без
              использования средств автоматизации, обработку и использование его персональных данных, действуют на
              протяжении действия этого Договора.
            </li>
          </ol>
        </li>
        <li>
          Другие условия
          <ol className={s.list}>
            <li>
              Все правоотношения, которые возникают из настоящего Договора или связанные с ним, в том числе связанные с
              действительностью, заключением, исполнением, изменением и прекращением настоящего Договора, толкованием
              его условий, определением последствий недействительности или нарушения Договора, регламентируются
              настоящим Договором и соответствующими нормами действующего законодательства РФ, а также применимыми к
              таким правоотношениям обычаями делового оборота на основании принципов добросовестности, разумности и
              справедливости.
            </li>
            <li>
              После заключения настоящего Договора все предыдущие переговоры по нему, переписка, предварительные
              договоры, протоколы о намерениях и любые другие устные или письменные договоренности Сторон по вопросам,
              которые так или иначе касаются этого Договора, теряют юридическую силу.
            </li>
            <li>
              Лицензиар несет полную ответственность за правильность указанной при регистрации информации, и обязуется
              своевременно сообщать Лицензиату об ее изменении, а в случае не сообщения несет риск наступления связанных
              с этим неблагоприятных последствий.
            </li>
            <li>
              Заключение этого договора свидетельствует о согласии Лицензиара для улучшения УИТП на осуществление
              обработки его данных, в том числе персональных, предоставляемых Лицензиату в соответствии с требованиями
              законодательства РФ, а также аудиозаписей, всех телефонных разговоров со специалистом УИТП Лицензиата.
            </li>
            <li>
              В случае наличия у Лицензиара, подписанного в письменном виде с Лицензиатом лицензионного договора,
              правоотношения по предоставлению Лицензиару Права регулируются таким договором.
            </li>
            <li>
              В иных случаях правоотношения по предоставлению Лицензиару Права регулируются вышеизложенным лицензионным
              договором.
            </li>
          </ol>
        </li>
      </ol>
      <div className={cn(s.button, s.noPrint)}>
        <Button fixedWidth={220} center onClick={() => window.close()}>
          Закрыть соглашение
        </Button>
        <Button fixedWidth={220} center theme="black" onClick={() => window.print()}>
          Печать
        </Button>
      </div>
    </div>
  </div>
);

export default TermsAndConditions;
